const APP_VARIANT = import.meta.env.VITE_APP_VARIANT ?? "default";

export const isCarouselOnlyApp = APP_VARIANT === "carousel";

export const getPostLoginRoute = () => {
  return isCarouselOnlyApp ? "/carousel" : "/";
};
